import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Flechas anterior/siguiente para las vistas de detalle (proveedor/comunidad).
// prev / next son el nif vecino (o null en los extremos). basePath es la ruta
// del detalle (p. ej. "/proveedores"). Si no hay ningún vecino, no se renderiza nada.
const baseCls =
  "inline-flex items-center justify-center w-8 h-8 rounded-md border border-gray-200 bg-white transition-colors";

const PrevNextNav = ({ prev, next, basePath }) => {
  if (!prev && !next) return null;

  const disabledCls = `${baseCls} text-gray-300 cursor-default pointer-events-none`;
  const enabledCls = `${baseCls} text-gray-700 hover:bg-gray-50 cursor-pointer`;

  return (
    <div className="flex items-center gap-1 flex-shrink-0">
      {prev ? (
        <Link to={`${basePath}/${prev}`} className={enabledCls} aria-label="Anterior" title="Anterior">
          <ChevronLeft className="w-4 h-4" />
        </Link>
      ) : (
        <span className={disabledCls} aria-disabled="true">
          <ChevronLeft className="w-4 h-4" />
        </span>
      )}
      {next ? (
        <Link to={`${basePath}/${next}`} className={enabledCls} aria-label="Siguiente" title="Siguiente">
          <ChevronRight className="w-4 h-4" />
        </Link>
      ) : (
        <span className={disabledCls} aria-disabled="true">
          <ChevronRight className="w-4 h-4" />
        </span>
      )}
    </div>
  );
};

export default PrevNextNav;
